import {memo, ReactNode} from 'react';
import styled from 'styled-components';
import {MOBILE_BREAKPOINT} from './constants';

interface CardFooterProps {
  children: ReactNode;
}

export const CardFooter = memo(({children}: CardFooterProps) => {
  return <FooterWrapper>{children}</FooterWrapper>;
});

const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  /* Mobile responsiveness */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;
